import api from "./api";

// One small function per backend endpoint. Components never build URLs themselves.
export const getCategories = () => api.get("/v1/public/categories").then((r) => r.data);
export const getProducts = (type) =>
  api.get("/v1/public/products", { params: type ? { type } : {} }).then((r) => r.data);
export const getFaqs = () => api.get("/v1/public/faqs").then((r) => r.data);
export const getSampleResults = () => api.get("/v1/public/sample-results").then((r) => r.data);
export const getMyResults = () => api.get("/v1/results").then((r) => r.data);
export const createOrder = (lines) => api.post("/v1/orders", { lines }).then((r) => r.data);
export const getMyOrders = () => api.get("/v1/orders").then((r) => r.data);
export const sendContact = (body) => api.post("/v1/contact", body).then((r) => r.data);

/** Turns an API error into a short message safe to show to a person. */
export function errorMessage(err, fallback = "Something went wrong. Please try again.") {
  const data = err?.response?.data;
  if (data?.fieldErrors) return Object.values(data.fieldErrors).join(" ");
  if (data?.message) return data.message;
  if (err?.code === "ERR_NETWORK") return "Cannot reach the server right now.";
  return fallback;
}

// ---- Care, testing, membership, learn (public) and visits (signed in) ----
export const getTreatmentCategories = (audience) =>
  api.get("/v1/public/treatment-categories", { params: audience ? { audience } : {} }).then((r) => r.data);
export const getTreatments = (category) =>
  api.get("/v1/public/treatments", { params: category ? { category } : {} }).then((r) => r.data);
export const getTreatment = (slug) => api.get(`/v1/public/treatments/${encodeURIComponent(slug)}`).then((r) => r.data);
export const getIntakeQuestions = () => api.get("/v1/public/intake-questions").then((r) => r.data);
export const getTestingOptions = () => api.get("/v1/public/testing-options").then((r) => r.data);
export const getTestingOption = (slug) => api.get(`/v1/public/testing-options/${encodeURIComponent(slug)}`).then((r) => r.data);
export const getMemberships = () => api.get("/v1/public/memberships").then((r) => r.data);
export const getLearn = (type) => api.get("/v1/public/learn", { params: type ? { type } : {} }).then((r) => r.data);
export const submitVisit = (body) => api.post("/v1/visits", body).then((r) => r.data);
export const getMyVisits = () => api.get("/v1/visits").then((r) => r.data);

// ---- VitaRelay (Rx catalog and orders). Admin only; the server holds the API key. ----
export const getVitaRelayStatus = () => api.get("/v1/vitarelay/status").then((r) => r.data);
export const getRxCatalog = (params) => api.get("/v1/vitarelay/catalog", { params }).then((r) => r.data);
export const getRxOrders = (params) => api.get("/v1/vitarelay/orders", { params }).then((r) => r.data);
export const placeRxOrder = (body) => api.post("/v1/vitarelay/orders", body).then((r) => r.data);

// ---- Telehealth intake for prescription products (Admin only) ----
export const startTelehealthIntake = (body) => api.post("/v1/vitarelay/intake/start", body).then((r) => r.data);
export const referTelehealthIntake = (body) => api.post("/v1/vitarelay/intake/refer", body).then((r) => r.data);
